import React from "react";
import close from "../../../../../assets/img/dashboardSide/close.svg";
import PropTypes from "prop-types";

const VideoModal = ({selectedVideo, showVideoModal, setShowVideoModal}) => {
    return (
        <>
            <div id={"modalVideo"}>
                <div id={"modalVideo-container"}>
                    <video controls="true" src={selectedVideo}>
                        Ici la description alternative
                    </video>
                </div>
                <div className={"close"}
                     onClick={() =>
                         setShowVideoModal(false)
                     }
                     src={close}
                >
                    <img
                        src="https://www.prevandcare.com/modules/aidant/messagerie/build/static/media/close.2c1ebd35.svg"
                        alt="fermé"/>
                </div>
            </div>
            <div
                className="modalBackground"
                onClick={() => (showVideoModal ? setShowVideoModal(false) : null)}
            ></div>
        </>
    );
};

VideoModal.propTypes = {
    selectedVideo: PropTypes.string,
    showVideoModal: PropTypes.bool,
    setShowVideoModal: PropTypes.func
};

export default VideoModal;